export const sources = {
  art52: {
    label: "Art. 52 EPÜ",
    url: "https://www.epo.org/de/legal/epc/2020/a52.html",
  },
  art54: {
    label: "Art. 54 EPÜ",
    url: "https://www.epo.org/de/legal/epc/2020/a54.html",
  },
  art56: {
    label: "Art. 56 EPÜ",
    url: "https://www.epo.org/de/legal/epc/2020/a56.html",
  },
  psa: {
    label: "EPA-Richtlinien G-VII, 5",
    url: "https://www.epo.org/de/legal/guidelines-epc/2026/g_vii_5.html",
  },
  psaClosest: {
    label: "EPA-Richtlinien G-VII, 5.1",
    url: "https://www.epo.org/de/legal/guidelines-epc/2026/g_vii_5_1.html",
  },
  psaProblem: {
    label: "EPA-Richtlinien G-VII, 5.2",
    url: "https://www.epo.org/de/legal/guidelines-epc/2026/g_vii_5_2.html",
  },
  art87: {
    label: "Art. 87 EPÜ",
    url: "https://www.epo.org/de/legal/epc/2020/a87.html",
  },
  art123: {
    label: "Art. 123 EPÜ",
    url: "https://www.epo.org/de/legal/epc/2020/a123.html",
  },
  addedMatter: {
    label: "EPA-Richtlinien H-IV, 2.1",
    url: "https://www.epo.org/de/legal/guidelines-epc/2026/h_iv_2_1.html",
  },
  pct3: {
    label: "Art. 3 PCT",
    url: "https://www.wipo.int/de/web/pct-system/texts/articles/a3",
  },
  pct8: {
    label: "Art. 8 PCT",
    url: "https://www.wipo.int/de/web/pct-system/texts/articles/a8",
  },
  pct11: {
    label: "Art. 11 PCT",
    url: "https://www.wipo.int/de/web/pct-system/texts/articles/a11",
  },
  pct15: {
    label: "Art. 15 PCT",
    url: "https://www.wipo.int/de/web/pct-system/texts/articles/a15",
  },
  pct18: {
    label: "Art. 18 PCT",
    url: "https://www.wipo.int/de/web/pct-system/texts/articles/a18",
  },
  pct33: {
    label: "Art. 33 PCT",
    url: "https://www.wipo.int/de/web/pct-system/texts/articles/a33",
  },
  patg: {
    label: "Patentgesetz",
    url: "https://www.gesetze-im-internet.de/patg/",
  },
  patg1: {
    label: "§ 1 PatG",
    url: "https://www.gesetze-im-internet.de/patg/__1.html",
  },
  patg3: {
    label: "§ 3 PatG",
    url: "https://www.gesetze-im-internet.de/patg/__3.html",
  },
  patg9: {
    label: "§ 9 PatG",
    url: "https://www.gesetze-im-internet.de/patg/__9.html",
  },
  patg10: {
    label: "§ 10 PatG",
    url: "https://www.gesetze-im-internet.de/patg/__10.html",
  },
  patg14: {
    label: "§ 14 PatG",
    url: "https://www.gesetze-im-internet.de/patg/__14.html",
  },
  patg1a: {
    label: "§ 1a PatG",
    url: "https://www.gesetze-im-internet.de/patg/__1a.html",
  },
  patg2: {
    label: "§ 2 PatG",
    url: "https://www.gesetze-im-internet.de/patg/__2.html",
  },
  patg2a: {
    label: "§ 2a PatG",
    url: "https://www.gesetze-im-internet.de/patg/__2a.html",
  },
  patg4: {
    label: "§ 4 PatG",
    url: "https://www.gesetze-im-internet.de/patg/__4.html",
  },
  patg5: {
    label: "§ 5 PatG",
    url: "https://www.gesetze-im-internet.de/patg/__5.html",
  },
  bghRoteTaube: {
    label: "BGH Rote Taube (1969)",
    url: "https://www.jurion.de/urteile/bgh/1969-03-27/x-zb-15_67/",
  },
  bgb: {
    label: "Bürgerliches Gesetzbuch",
    url: "https://www.gesetze-im-internet.de/bgb/",
  },
  bgb145: {
    label: "§ 145 BGB",
    url: "https://www.gesetze-im-internet.de/bgb/__145.html",
  },
  bgb158: {
    label: "§ 158 BGB",
    url: "https://www.gesetze-im-internet.de/bgb/__158.html",
  },
  bgb164: {
    label: "§ 164 BGB",
    url: "https://www.gesetze-im-internet.de/bgb/__164.html",
  },
  bgb194: {
    label: "§ 194 BGB",
    url: "https://www.gesetze-im-internet.de/bgb/__194.html",
  },
  hagenKe1: {
    label: "FernUni Hagen, Grundlagen des Buergerlichen Rechts, Kurseinheit 1",
    url: "../materials/hagen-jura/1.pdf",
  },
  bgb130: {
    label: "§ 130 BGB",
    url: "https://www.gesetze-im-internet.de/bgb/__130.html",
  },
  bgb133: {
    label: "§ 133 BGB",
    url: "https://www.gesetze-im-internet.de/bgb/__133.html",
  },
  bgb146: {
    label: "§ 146 BGB",
    url: "https://www.gesetze-im-internet.de/bgb/__146.html",
  },
  bgb147: {
    label: "§ 147 BGB",
    url: "https://www.gesetze-im-internet.de/bgb/__147.html",
  },
  bgb150: {
    label: "§ 150 BGB",
    url: "https://www.gesetze-im-internet.de/bgb/__150.html",
  },
  bgb151: {
    label: "§ 151 BGB",
    url: "https://www.gesetze-im-internet.de/bgb/__151.html",
  },
  bgb154: {
    label: "§ 154 BGB",
    url: "https://www.gesetze-im-internet.de/bgb/__154.html",
  },
  bgb155: {
    label: "§ 155 BGB",
    url: "https://www.gesetze-im-internet.de/bgb/__155.html",
  },
  bgb241a: {
    label: "§ 241a BGB",
    url: "https://www.gesetze-im-internet.de/bgb/__241a.html",
  },
  bgb305: {
    label: "§ 305 BGB",
    url: "https://www.gesetze-im-internet.de/bgb/__305.html",
  },
  bgb305b: {
    label: "§ 305b BGB",
    url: "https://www.gesetze-im-internet.de/bgb/__305b.html",
  },
  bgb305c: {
    label: "§ 305c BGB",
    url: "https://www.gesetze-im-internet.de/bgb/__305c.html",
  },
  bgb311: {
    label: "§ 311 BGB",
    url: "https://www.gesetze-im-internet.de/bgb/__311.html",
  },
  bgb312i: {
    label: "§ 312i BGB",
    url: "https://www.gesetze-im-internet.de/bgb/__312i.html",
  },
  bgb312j: {
    label: "§ 312j BGB",
    url: "https://www.gesetze-im-internet.de/bgb/__312j.html",
  },
  bgb433: {
    label: "§ 433 BGB",
    url: "https://www.gesetze-im-internet.de/bgb/__433.html",
  },
  hgb346: {
    label: "§ 346 HGB",
    url: "https://www.gesetze-im-internet.de/hgb/__346.html",
  },
  patg34: {
    label: "§ 34 PatG",
    url: "https://www.gesetze-im-internet.de/patg/__34.html",
  },
  patg35: {
    label: "§ 35 PatG",
    url: "https://www.gesetze-im-internet.de/patg/__35.html",
  },
  patg36: {
    label: "§ 36 PatG",
    url: "https://www.gesetze-im-internet.de/patg/__36.html",
  },
  patg37: {
    label: "§ 37 PatG",
    url: "https://www.gesetze-im-internet.de/patg/__37.html",
  },
  patg38: {
    label: "§ 38 PatG",
    url: "https://www.gesetze-im-internet.de/patg/__38.html",
  },
  patg42: {
    label: "§ 42 PatG",
    url: "https://www.gesetze-im-internet.de/patg/__42.html",
  },
  patg44: {
    label: "§ 44 PatG",
    url: "https://www.gesetze-im-internet.de/patg/__44.html",
  },
  patg45: {
    label: "§ 45 PatG",
    url: "https://www.gesetze-im-internet.de/patg/__45.html",
  },
  hagenKe2: {
    label: "FernUni Hagen, Grundlagen des Buergerlichen Rechts, Kurseinheit 2",
    url: "../materials/hagen-jura/2.pdf",
  },
  bgb104: { label: "§ 104 BGB", url: "https://www.gesetze-im-internet.de/bgb/__104.html" },
  bgb107: { label: "§ 107 BGB", url: "https://www.gesetze-im-internet.de/bgb/__107.html" },
  bgb108: { label: "§ 108 BGB", url: "https://www.gesetze-im-internet.de/bgb/__108.html" },
  bgb110: { label: "§ 110 BGB", url: "https://www.gesetze-im-internet.de/bgb/__110.html" },
  bgb119: { label: "§ 119 BGB", url: "https://www.gesetze-im-internet.de/bgb/__119.html" },
  bgb121: { label: "§ 121 BGB", url: "https://www.gesetze-im-internet.de/bgb/__121.html" },
  bgb122: { label: "§ 122 BGB", url: "https://www.gesetze-im-internet.de/bgb/__122.html" },
  bgb123: { label: "§ 123 BGB", url: "https://www.gesetze-im-internet.de/bgb/__123.html" },
  bgb124: { label: "§ 124 BGB", url: "https://www.gesetze-im-internet.de/bgb/__124.html" },
  bgb125: { label: "§ 125 BGB", url: "https://www.gesetze-im-internet.de/bgb/__125.html" },
  bgb134: { label: "§ 134 BGB", url: "https://www.gesetze-im-internet.de/bgb/__134.html" },
  bgb138: { label: "§ 138 BGB", url: "https://www.gesetze-im-internet.de/bgb/__138.html" },
  bgb139: { label: "§ 139 BGB", url: "https://www.gesetze-im-internet.de/bgb/__139.html" },
  bgb142: { label: "§ 142 BGB", url: "https://www.gesetze-im-internet.de/bgb/__142.html" },
  bgb157: { label: "§ 157 BGB", url: "https://www.gesetze-im-internet.de/bgb/__157.html" },
  bgb311b: { label: "§ 311b BGB", url: "https://www.gesetze-im-internet.de/bgb/__311b.html" },
};
